// extracted by mini-css-extract-plugin
export var avatar = "_q7-3";
export var avatarContainer = "_q7-2";
export var avatarSpacer = "_q7-5";
export var avatarSpacerContainer = "_q7-4";
export var avatarStackContainer = "_q7-1";
export var bubble = "_q7-0";
export var remainderBubble = "_q7-6";